<template>
    <div>
        <v-card
            outlined
            v-for="(item, idx) in getcartlist"
            :key="'A'+idx"
        >
            <v-list-item class="title__stys">
                <v-list-item-title class="title__sty white--text">{{getcartlist[idx][0]}}</v-list-item-title>
                <div class="text-center">
                <v-btn
                    icon
                    x-small
                    class="white--text"
                    @click="delAllProduct(idx)"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                </div>
            </v-list-item>
            <v-divider></v-divider>
            <!-- items -->
            <div
                v-for="(subitem, subidx) in item.slice(1)"
                :key="'B'+subidx"
            >
                <v-list-item class="normal_title__stys" v-if="getcartlist[idx][subidx+1][0] === '常溫宅配'">
                    <v-list-item-title class="title__sty white--text">{{getcartlist[idx][subidx+1][0]}}<font class="float-right">{{getseparateshippingdesc[idx].normal}}</font></v-list-item-title>
                </v-list-item>
                <v-list-item class="fridge_title__stys" v-else-if="getcartlist[idx][subidx+1][0] === '冷凍宅配'">
                    <v-list-item-title class="title__sty white--text">{{getcartlist[idx][subidx+1][0]}}<font class="float-right">{{getseparateshippingdesc[idx].freezing}}</font></v-list-item-title>
                </v-list-item>
                <v-list-item class="freezer_title__stys" v-else>
                    <v-list-item-title class="title__sty white--text">{{getcartlist[idx][subidx+1][0]}}<font class="float-right">{{getseparateshippingdesc[idx].refrigeration}}</font></v-list-item-title>
                </v-list-item>
                <div
                    v-for="(subsubitem, subsubidx) in subitem.slice(1)"
                    :key="'C'+subsubidx"
                >
                    <v-list-item>
                        <v-row no-gutters class="subarea__shop__sty">
                            <v-col cols="3">
                                <v-img
                                    :src="subsubitem.url"
                                    :alt="subsubitem.name"
                                    class="img__sty"
                                ></v-img>
                            </v-col>
                            <v-col cols="8" class="shop__name__sty">
                                {{ subsubitem.name }}
                                <div class="mt-2">
                                    <div class="select" v-if="subsubitem.number < 10">
                                        <select
                                            v-model="subsubitem.number"
                                            @change="biggerten_onChange($event, subsubidx, subidx, idx)"
                                        >
                                            <option
                                                v-for="(option, idx) in subsubitem.canbuy_list"
                                                :key="'B' + idx"
                                                :value="option"
                                            >
                                                {{ option }}
                                            </option>
                                        </select>
                                        <div class="select_arrow"></div>
                                    </div>
                                    <div class="mb-n5" v-else>
                                        <v-text-field
                                            outlined
                                            :label="$t('ProductBuy_input1')"
                                            :value="subsubitem.number"
                                            @change="biggerten_onChange_Calculate($event, subsubidx, subidx, idx)"
                                        ></v-text-field>
                                    </div>
                                </div>
                                <div class="shop__price__sty">{{$t('ProductBuy_text1')}} NT$ {{ subsubitem.special_price }}</div>
                            </v-col>
                            <v-col cols="1" class="text-right">
                                <div>
                                    <v-btn
                                    icon
                                    x-small
                                    class="black--text"
                                    @click="delProduct(subsubidx, subidx, idx)"
                                    >
                                    <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-list-item>
                </div>
            </div>
            <div class="px-4 py-2 shipping__area__sty">
                <p class="mb-0">{{getcartlist[idx][0]}}{{$t('ProductBuy_text2')}}：<font>{{$t('ProductBuy_text7')}}{{$t('ProductBuy_text2_1')}} / </font><font v-show="getcartshippingfree[idx].shipping !== 0">{{$t('ProductBuy_text3')}} NT${{getcartshippingfree[idx].shipping}} / </font><font v-show="getcartshippingfree[idx].refrigeration_shipping !== 0">{{$t('ProductBuy_text5')}} NT${{getcartshippingfree[idx].refrigeration_shipping}} / </font><font v-show="getcartshippingfree[idx].freezing_shipping !== 0">{{$t('ProductBuy_text4')}} NT${{getcartshippingfree[idx].freezing_shipping}}</font>{{$t('ProductBuy_text6')}}</p>
            </div>
        </v-card>
    </div>
</template>

<script>
    export default {
        name: 'BuyProduct',
        props: ['getcartlist', 'getseparateshippingdesc', 'getcartshippingfree'],

        data: () => ({
            newPutCartList: []
        }),
        computed: {
        },
        methods: {
            // 重新計算金額
            reCalculate() {
                // 更改運費/商品小計
                this.axios({
                    method: 'post',
                    url: `https://${process.env.VUE_APP_API}.cheerlife.io/cart/v1/productions/cart-list`,
                    data: {
                        access_key: process.env.VUE_APP_ACCESSKEY,
                        productions: this.$store.state.putcartlist.putcartData,
                    },
                })
                    .then((response) => {
                        this.$store.state.shippingprice.shippingpriceData.price = response.data.price;
                        this.$store.state.shippingprice.shippingpriceData.totalshippingfee = response.data.total_shipping_fee;
                        this.$store.state.shippingprice.shippingpriceData.separateshippingfree = response.data.separate_shipping_free;
                        this.$store.state.shippingprice.shippingpriceData.separateshippingdesc = response.data.separate_shipping_desc;
                        this.$store.state.shippingprice.shippingpriceData.oldprice = response.data.price;
                        this.$store.state.shippingprice.shippingpriceData.cheerpointlimit = response.data.cheer_point_limit;
                        this.$store.state.shippingprice.shippingpriceData.shopmoneylimit = response.data.shop_money_limit;
                        this.$emit('childsend', true);
                    })
                    .catch((error) => {
                        alert(error.response.data.message);
                    });
            },
            // 便當更改+10以上數量
            biggerten_onChange(event, subsubi, subi, i) {
                let count = event.target.value;
                if (event.target.value === '+10') {
                    count = 10;
                }
                this.getcartlist[i][subi+1][subsubi+1].number = String(count);
                this.$store.state.getcartlist.getcartData = this.getcartlist;
                this.newPutCartList = [];
                for (let i = 0; i < this.getcartlist.length; i++) {
                    for (let j = 1; j < this.getcartlist[i].length; j++) {
                        for (let k = 1; k < this.getcartlist[i][j].length; k++) {
                            this.newPutCartList.push(
                                { production_id: parseInt(this.getcartlist[i][j][k].product_id), qty: parseInt(this.getcartlist[i][j][k].number) }
                            );
                        }
                    }
                }
                this.$store.state.putcartlist.putcartData = this.newPutCartList;
                // 重新計算金額:
                this.reCalculate();
            },
            biggerten_onChange_Calculate(num, subsubi, subi, i) {
                this.getcartlist[i][subi+1][subsubi+1].number = String(num);
                this.newPutCartList = [];
                for (let i = 0; i < this.getcartlist.length; i++) {
                    for (let j = 1; j < this.getcartlist[i].length; j++) {
                        for (let k = 1; k < this.getcartlist[i][j].length; k++) {
                            this.newPutCartList.push(
                                { production_id: parseInt(this.getcartlist[i][j][k].product_id), qty: parseInt(this.getcartlist[i][j][k].number) }
                            );
                        }
                    }
                }
                this.$store.state.putcartlist.putcartData = this.newPutCartList;
                // 重新計算金額:
                this.reCalculate();
            },
            delAllProduct(getidx) {
                const result = confirm(`您確定要清空${this.getcartlist[getidx][0]}購物車？`);
                if (result === false) {
                    return false;
                } else {
                    // 刪除後端整理購物車 array
                    this.$store.state.getcartlist.getcartData.splice(getidx, 1);
                    // 判斷購物車數量, 如果0返回
                    if (this.$store.state.getcartlist.getcartData.length === 0) {
                        this.$store.state.putcartlist.putcartData = [];
                        this.$router.push('/');
                    } else {
                        // 更改前端整理 array
                        this.newPutCartList = [];
                        for (let i = 0; i < this.$store.state.getcartlist.getcartData.length; i++) {
                            for (let j = 1; j < this.$store.state.getcartlist.getcartData[i].length; j++) {
                                for (let k = 1; k < this.getcartlist[i][j].length; k++) {
                                    this.newPutCartList.push(
                                        { production_id: parseInt(this.$store.state.getcartlist.getcartData[i][j][k].product_id), qty: parseInt(this.$store.state.getcartlist.getcartData[i][j][k].number) }
                                    );
                                }
                            }
                        }
                        this.$store.state.putcartlist.putcartData = this.newPutCartList;
                        this.reCalculate();
                    }
                }
            },
            delProduct(subsubidx, subidx, idx) {
                const result = confirm("您確定要刪除此商品？");
                if (result === false) {
                    return false;
                } else {
                    // 刪除後端整理購物車 array
                    if (this.$store.state.getcartlist.getcartData[idx][subidx+1].length <= 2) {
                        if (this.$store.state.getcartlist.getcartData[idx].length <= 2) {
                            this.$store.state.getcartlist.getcartData.splice(idx, 1);
                        } else {
                            this.$store.state.getcartlist.getcartData[idx].splice(subidx+1, 1);
                        }
                    } else {
                        this.$store.state.getcartlist.getcartData[idx][subidx+1].splice(subsubidx+1, 1);
                    }
                    // 判斷購物車數量, 如果0返回
                    if (this.$store.state.getcartlist.getcartData.length === 0) {
                        this.$store.state.putcartlist.putcartData = [];
                        this.$router.push('/');
                    } else {
                        // 更改前端整理 array
                        this.newPutCartList = [];
                        for (let i = 0; i < this.$store.state.getcartlist.getcartData.length; i++) {
                            for (let j = 1; j < this.$store.state.getcartlist.getcartData[i].length; j++) {
                                for (let k = 1; k < this.getcartlist[i][j].length; k++) {
                                    this.newPutCartList.push(
                                        { production_id: parseInt(this.$store.state.getcartlist.getcartData[i][j][k].product_id), qty: parseInt(this.$store.state.getcartlist.getcartData[i][j][k].number) }
                                    );
                                }
                            }
                        }
                        this.$store.state.putcartlist.putcartData = this.newPutCartList;
                        this.reCalculate();
                    }
                }
            },
        },
    }
</script>
<style lang="sass">
    .row.no-gutters > .col.shop__name__sty
        padding: 0 11px 0px 16px
</style>
<style scoped lang="sass"> 
    .subbtn__sty
        background: #D2DDF0
        color: #352D40
        font-weight: bold
        font-size: 13px
        letter-spacing: 0.1em
    .title__stys
        background-color: #352D40
    // 常溫宅配
    .normal_title__stys
        background-color: #ED7978
    // 冷藏宅配
    .fridge_title__stys
        background-color: #3AAEA5
    // 冷凍宅配
    .freezer_title__stys
        background-color: #1A78C9
    .title__sty
        font-weight: bold
        font-size: 15px
        letter-spacing: 0.1em
    .subprice__sty
        font-weight: bold
        font-size: 12px
        letter-spacing: 0.1em
    .subarea__shop__sty
        padding: 10px 0
    .shop__name__sty
        color: #352D40
        font-weight: bold
        line-height: 17px
        font-size: 15px
    .shop__price__sty
        color: #3AAEA5
        font-weight: bold
        font-size: 13px
    .img__sty
        width: 70px
        height: 70px
    .select
        position: relative
        display: inline-block
        margin-bottom: 15px
        width: 100%
    .select select
        display: inline-block
        width: 100%
        cursor: pointer
        padding: 5px 15px
        outline: 0
        border: 1px solid #EAE4E2
        border-radius: 0
        color: #352D40
        appearance: none
        -webkit-appearance: none
        -moz-appearance: none
    .select select::-ms-expand
        display: none
    .select select:hover,
    .select select:focus
        color: #000
        background: #ccc
    .select select:disabled
        opacity: 0.5
        pointer-events: none
    .select_arrow
        position: absolute
        top: 11px
        right: 15px
        width: 0
        height: 0
        pointer-events: none
        border-style: solid
        border-width: 8px 5px 0 5px
        border-color: #352D40 transparent transparent transparent
    .select select:hover ~ .select_arrow,
    .select select:focus ~ .select_arrow
        border-top-color: #000
    .select select:disabled ~ .select_arrow
        border-top-color: #ccc
    .shipping__area__sty
        background: #EAE4E2
    .shipping__area__sty p
        font-weight: bold
        font-size: 13px
        line-height: 17px
        letter-spacing: 0.1em
        color: #000000
    @media only screen and (max-width: 529px)
        .shop__price__sty
            margin-top: -8px
</style>
